// 获取当前浏览器私有属性
export const browserPrefix = () => {
  const vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'];
  let transform;
  const elementStyle = document.createElement('div').style;
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < vendors.length; i++) {
    transform = vendors[i] + 'ransform';
    if (transform in elementStyle) {
      return vendors[i].substr(0, vendors[i].length - 1);
    }
  }
  return false;
};
// 添加style浏览器私有属性
export const addPrefixStyle = (styleName: string) => {
  const vendor = browserPrefix();
  if (vendor === false) {
    return '';
  }
  if (vendor === '') {
    return styleName;
  }
  return vendor + styleName.charAt(0).toUpperCase() + styleName.substr(1);
};

export const getTouchAction = (eventPassthrough, addPinch) => {
  let touchAction = 'none';
  if (eventPassthrough === 'vertical') {
    touchAction = 'pan-y';
  } else if (eventPassthrough === 'horizontal') {
    touchAction = 'pan-x';
  }
  if (addPinch && touchAction !== 'none') {
    // add pinch-zoom support if the browser supports it, but if not (eg. Chrome <55) do nothing
    touchAction += ' pinch-zoom';
  }
  return touchAction;
};

export class TouchableService {
  private deltaX = 0;
  private deltaY = 0;
  private pointX = 0;
  private pointY = 0;
  private distX = 0;
  private distY = 0;
  private directionLocked = '';
  private directionLockThreshold = 5;
  private disableTouchMove = true;

  public handleTouchStart = (e) => {
    if (this.multiTouchDisable(e)) {
      const point = e.touches ? e.touches[0] : e;
      this.pointX = point.pageX;
      this.pointY = point.pageY;
      this.distX = 0;
      this.distY = 0;
      this.directionLocked = '';
    }
  };

  public handleTouchMove = (e) => {
    if (this.multiTouchDisable(e)) {
      const point = e.touches ? e.touches[0] : event;
      this.deltaX = point.pageX - this.pointX;
      this.deltaY = point.pageY - this.pointY;
      this.pointX = point.pageX;
      this.pointY = point.pageY;
      this.distX += this.deltaX;
      this.distY += this.deltaY;

      const absDistX = Math.abs(this.distX);
      const absDistY = Math.abs(this.distY);
      if (!this.directionLocked) {
        if (absDistX > absDistY + this.directionLockThreshold) {
          this.directionLocked = 'h'; // lock horizontally
        } else if (absDistY >= absDistX + this.directionLockThreshold) {
          this.directionLocked = 'v'; // lock vertically
        } else {
          this.directionLocked = 'n'; // no lock
        }
      }
      // console.log('unTouchable service touch move direction: `', this.directionLocked, '`');
      if (this.directionLocked === 'h') {
        // return;
      }
      if (this.disableTouchMove) {
        console.log('native-lock-scroll', 'preventDefault');
        e.preventDefault();
      }
    }
  };

  private multiTouchDisable(e) {
    if (e.touches.length > 1 || e.targetTouches.length > 1) {
      console.log('multi touch found!');
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    } else {
      return true;
    }
  }

  public changeTouchAction(element) {
    if (!element) {
      return;
    }
    if (this.disableTouchMove) {
      element.style[addPrefixStyle('touchAction')] = getTouchAction('horizontal', true);
    } else {
      element.style[addPrefixStyle('touchAction')] = 'initial';
    }
  }

  public changeDisableTouchMove(disableTouchMove: boolean, element) {
    this.disableTouchMove = disableTouchMove;
    this.changeTouchAction(element);
  }
}
